import React, { useEffect, useState} from "react";
import {
  Row,
  Col,
  Alert,
} from "antd";
import { BASE_PADDING } from "constants/Layout";
import GlobalSettingAPI from 'restAPI/GlobalSettingAPI';

const TicketCreatedWarning = (findings, ticketCreated) => {
  const [allowMultipleTickets, setAllowMultipleTickets] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const { promise, cancel } = GlobalSettingAPI.getCustomizedTicketSetting();
    promise
      .then((data) => setAllowMultipleTickets(data.allowMultipleTickets))
      .finally(() => setIsLoading(false));
    return cancel;
  }, []);

  if (isLoading || allowMultipleTickets) {
    return { findingsWithTicketCount: 0 };
  }
  const findingsWithTicket = [];
  findings.forEach((finding) => {
    if(finding.armorcodeTicket?.length > 0) {
      findingsWithTicket.push(finding.id);
    }
  });
  
  let warningText = `Finding(s) ${findingsWithTicket.join(', ')} already have tickets created`;
  if (!ticketCreated) {
    warningText = `${warningText} and new tickets will not be created for these findings.`
  }

  return findingsWithTicket.length > 0 ? {
    findingsWithTicketWarning: <Row gutter={[BASE_PADDING, BASE_PADDING]}>
      <Col span={24}>
        <Alert type="warning" showIcon message={warningText} />
      </Col>
    </Row>,
    findingsWithTicketCount: findingsWithTicket.length
  } : {
    findingsWithTicketCount: 0
  };
}

export default TicketCreatedWarning;